// extracted by mini-css-extract-plugin
module.exports = {"furtherInfo":"FurtherInfo_furtherInfo__nTAKB","popover":"FurtherInfo_popover__OiA_k"};